export default __webpack_public_path__ + "static/OYOY-1680x340-30fps-627cb1cdbf3f82efc9de167b94a6299b.mp4";